import React from "react";
import { Input } from "antd";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import { Select } from "antd";
const { Option } = Select;

const handleChange = (value) => {
  console.log(`selected ${value}`);
};

const cardDetailContent = () => {
  return (
    <div className="card-detail-content">
      <Row>
        <Col sm={6}>
          <div className="card-user-content">
            <Row>
              <Col lg={4}>
                <div className="detail-field">Card Holder Name*</div>
              </Col>
              <Col lg={8}>
                <div>
                  <Input placeholder="Enter your card name" />
                </div>
              </Col>
            </Row>
          </div>
        </Col>

        <Col sm={6}>
          <div className="card-user-content">
            <Row>
              <Col lg={4}>
                <div className="detail-field">Card Number*</div>
              </Col>
              <Col lg={8}>
                <div>
                  <Input type="password" placeholder="Enter card number" />
                </div>
              </Col>
            </Row>
          </div>
        </Col>
      </Row>

      <Row>
        <Col sm={6}>
          <div className="card-user-content">
            <Row>
              <Col lg={4}>
                <div className="detail-field">Expiry Month/year</div>
              </Col>
              <Col lg={8}>
                <Row>
                  <Col>
                    {" "}
                    <Select
                      defaultValue="Month"
                      // style={{
                      //   width: 100,
                      // }}
                      onChange={handleChange}
                    >
                      <Option value="jack">Jan</Option>
                      <Option value="lucy">Feb</Option>
                    </Select>
                  </Col>
                  <Col>
                    {" "}
                    <Select
                      defaultValue="Year"
                      // style={{
                      //   width: 120,
                      // }}
                      onChange={handleChange}
                    >
                      <Option value="jack">2022</Option>
                      <Option value="lucy">2021</Option>
                    </Select>
                  </Col>
                </Row>
                {/* <div></div> */}
              </Col>
            </Row>
          </div>
        </Col>

        <Col sm={6}>
          <div className="card-user-content">
            <Row>
              <Col lg={4}>
                <div className="detail-field">CVV*</div>
              </Col>
              <Col lg={8}>
                <div>
                  <Input type="password" placeholder="Enter your cvv" />
                </div>
              </Col>
            </Row>
          </div>
        </Col>
      </Row>
      {/* </Row> */}
    </div>
  );
};

export default cardDetailContent;
